// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".research-practice[data-v-457fcd71]{position:relative}.research-practice .map_view[data-v-457fcd71]{width:100%;height:100%}.research-practice .map_view .tdt-control-copyright[data-v-457fcd71]{display:none}", ""]);
// Exports
module.exports = exports;
